import { UNAUTHORIZED_CODE } from 'constants/request-code'
import { URL_PUBLIC } from 'constants/urls'
import { useAuth } from 'modules/auth'
import { type ComponentType, FC, useEffect } from 'react'
import { useRouter } from 'modules/navigation'
import { STORE_STATUS_FINISHED } from 'constants/store'

export const withAuth = <P extends object>(
  Component: ComponentType<P>
): FC<P> => {
  function WithAuth(props: P) {
    const {
      subscribe,
      auth: { error, data, status },
    } = useAuth()
    const router = useRouter()

    function redirectToLogin() {
      const url = location.pathname
      if (url !== '/') {
        router.push({ pathname: URL_PUBLIC, search: `?url=${url}` })
      } else {
        router.push(URL_PUBLIC)
      }
    }

    useEffect(() => {
      const unsubscribe = subscribe(redirectToLogin)
      return () => {
        unsubscribe()
      }
    }, [])

    useEffect(() => {
      if (data.isAnonymous || (error && error.name === UNAUTHORIZED_CODE)) {
        redirectToLogin()
      }
    }, [error, data])

    return status === STORE_STATUS_FINISHED ? <Component {...props} /> : <></>
  }

  return WithAuth
}
